import type {Money} from "../../../../../lib/Money.ts";
import type {DrillDownLine} from "../../types/types.ts";

export interface BookingIndexLeg {
    accountCode: string;
    accountLabel: string;
    description: string | null;
    debit: Money;
    credit: Money;
}

export type BookingIndex = Map<string, BookingIndexLeg[]>;

export interface IndexableReportRow {
    account: {code: string; label_nl: string} | null;
    lines: DrillDownLine[];
}

export function buildBookingIndex(rows: IndexableReportRow[]): BookingIndex {
    const index: BookingIndex = new Map();
    for (const row of rows) {
        if (!row.account) continue;
        for (const line of row.lines) {
            if (!line.booking_id) continue;
            const legs = index.get(line.booking_id) ?? [];
            legs.push({
                accountCode: row.account.code,
                accountLabel: row.account.label_nl,
                description: line.description,
                debit: line.debit_amount,
                credit: line.credit_amount,
            });
            index.set(line.booking_id, legs);
        }
    }
    return index;
}
